import template from './process.html'
import service from './process.service'
import controller from './process.controller'
import './process.scss'

let module = angular.module('process', [
	'ionic'
])
.service('Process', service)
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.process', {
			url: '/process?:snapshot',
			views: {
				'tab-search': {
					template: template,
					controller: controller,
					controllerAs: 'process'
				}
			}
		})
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/process/process.js